module.exports = __webpack_public_path__ + "static/media/peopleGrey.d29a7077.svg";